import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'vanGFowlerBol';

const mapStateToProps = (state, ownProps) => {
	let vanGFowlerBols;
	let vanGFowlerBol;
	let vanGFowlerBolId;

	if (state.lists.vanGFowlerBolIds) {
		vanGFowlerBols = _.map(state.lists.vanGFowlerBolIds, (id) => state.maps.vanGFowlerBol[id]);
	}

	if (ownProps.vanGFowlerBol) {
		vanGFowlerBol = ownProps.vanGFowlerBol;
	} else {
		vanGFowlerBolId = ownProps.vanGFowlerBolId
			? ownProps.vanGFowlerBolId
			: _.get(ownProps, ['match', 'params', 'vanGFowlerBolId']);
		vanGFowlerBol = _.get(state.maps, ['vanGFowlerBol', vanGFowlerBolId]);
	}

	return {
		vanGFowlerBol,
		vanGFowlerBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationMap: state.maps.station,
		terminalMap: state.maps.terminal,
	};
};

const search = (p = {}) => {
	const { afterDateTime, bolNumber, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
				bolNumber,
			},
			dispatch,
			callback,
		});
	};
};

const uploadBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.uploadBol`,
			params,
			dispatch,
			callback,
		});
	};
};

const reparseBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.reparse`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			vanGFowlerBolSearch: search,
			vanGFowlerBolUpload: uploadBol,
			vanGFowlerBolReparse: reparseBol,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
